<template>
  <div
    class="custom-img top-nav"
    :class="type"
    v-if="extras['custom' + index + 'Display' + type].display == 1"
  >
    <a
      :target="
        extras['custom' + index + 'ImgUrl' + type].model.replace('https://', '')
          .length > 0
          ? '_blank'
          : ''
      "
      :href="
        extras['custom' + index + 'ImgUrl' + type].model.replace('https://', '')
          .length > 0
          ? extras['custom' + index + 'ImgUrl' + type].model
          : 'javascript:void(0)'
      "
      :style="{
        cursor:
          extras['custom' + index + 'ImgUrl' + type].model.replace(
            'https://',
            ''
          ).length > 0
            ? 'pointer'
            : 'default',
      }"
    >
      <img :src="extras['custom' + index + 'Img' + type].src" alt="" />
    </a>
  </div>
</template>

<script>
export default {
  name: "Custom",
  props: {
    extras: Object,
    index: Number,
    type: String,
  },
  created() {},
};
</script>

<style scoped></style>
